import React from "react";
import {Container} from "@mui/material";
import {smokyBlack} from "../../colours/scheme";

interface TextBannerProps {
    children: React.ReactNode
}

export function TextBanner({children}: TextBannerProps) {
    return <Container sx={{ backgroundColor: smokyBlack, padding: 1}} maxWidth="sm">
        {children}
    </Container>
}